export const DEMO_MODE = import.meta.env?.VITE_DEMO_MODE === "true";
export const DEMO_KEY = "campnect-demo-v1";
export const DEMO_AUTH_KEY = "campnect-demo-auth-v1";
